import { t } from '@lingui/macro';

import { useEntityWithDeviceCountLoader, useMaintenanceWindowFormStyles } from './MaintenanceWindowsUtils';
import FormSection from '../../form/FormSection';
import {
    MAINTENANCE_WINDOW_BUSINESS_SERVICES_COLUMNS,
    MAINTENANCE_WINDOW_BUSINESS_SERVICES_FIELD,
} from './MaintenanceWindowsConstants';
import { SORT_ASC } from '../../../utilities/FormUtilities';
import ListSelectorField from '../../form/ListSelectorField';

const initialSort = [{ property: 'name', direction: SORT_ASC }];
const selectionDataSource = {
    totalProperty: 'count',
    dataProperty: 'data',
    params: {
        searchFields: ['name'],
    },
    initialSort,
};

const selectedDataSource = {
    ...selectionDataSource,
    url: '/query/admin/business-services/findSelected',
};

const availableDataSource = {
    ...selectionDataSource,
    url: '/query/admin/business-services/findAvailable',
};

const idsDataSource = {
    params: selectionDataSource.params,
    url: '/query/admin/business-services/selectionUUIDs',
};

export function MaintenanceWindowsBusinessServicesSection({ formData, setBusinessServicesSelectionDirty, disabled }) {
    const styles = useMaintenanceWindowFormStyles();

    return (
        <FormSection title={t`Maintenance Window Business Services`}>
            <div className={styles.selectorWrapper}>
                <ListSelectorField
                    gridColumns={MAINTENANCE_WINDOW_BUSINESS_SERVICES_COLUMNS}
                    sorters={initialSort}
                    dbSelected={formData?.businessServices?.map((bs) => bs.id) || []}
                    selectedDataSource={selectedDataSource}
                    selectedLoaderFunction={useEntityWithDeviceCountLoader}
                    availableDataSource={availableDataSource}
                    availableLoaderFunction={useEntityWithDeviceCountLoader}
                    idsDataSource={idsDataSource}
                    fieldName={MAINTENANCE_WINDOW_BUSINESS_SERVICES_FIELD}
                    addButtonText={t`Add Business Services`}
                    setSelectionIsDirty={setBusinessServicesSelectionDirty}
                    isMultiRemove={false}
                    selectedEmptyGridText={t`There are no Business Services in this Maintenance Window`}
                    disabled={disabled}
                />
            </div>
        </FormSection>
    );
}
